import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.GeneratedPurchaseOrdersWidget.';
  public static readonly purchaseOrderNetAmount = `${Id.prefix}purchaseOrderNetAmount`;
  public static readonly purchaseOrderStatus = `${Id.prefix}purchaseOrderStatus`;
}

export class LangGeneratedPurchaseOrdersWidget {
  private constructor() {}

  public static purchaseOrderNetAmount(params: { label: string }): string {
    return interpolate(Id.purchaseOrderNetAmount, params);
  }

  public static purchaseOrderStatus(params: { status: string }): string {
    return interpolate(Id.purchaseOrderStatus, params);
  }
}

export class GeneratedPurchaseOrdersWidgetModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.purchaseOrderNetAmount,
      "{{glossary 'purchase-order:plural'}} (Net Amount) - {{label}}",
      'Title for generated purchase orders widget with date range'
    );
    register.add(Id.purchaseOrderStatus, '{{status}}', 'Purchase order status for chart legend');
  }
}
